import { useCallback, useEffect, useRef } from "react";
import { usePersistStore, useStore } from "../../store";
import { TrustapUserService } from "../../services";
import { useNavigate, useSearchParams } from "react-router-dom";

function TrustapAccountCallback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const code = searchParams.get("code") || false;
  const state = searchParams.get("state") || false;

  const { token } = usePersistStore((s: any) => s);
  const { setIsLoading, setErrorMessage } = useStore((s: any) => s);

  // OAuth authorization codes are single-use. React.StrictMode re-runs
  // effects in dev, and if the user double-mounts the component, the
  // second call would fail with "code already used". This ref ensures
  // we fire the exchange exactly once per mount lifecycle.
  const hasFiredRef = useRef(false);

  const verifyStateToken = useCallback(async () => {
    if (!token || !code || !state) return;
    setIsLoading(true);
    let result = await TrustapUserService.verifyAndFinalize(token, {
      stateToken: state,
      code: code,
    });
    if (result.error) {
      setErrorMessage(result.error);
      setIsLoading(false);
      return;
    }

    setIsLoading(false);
    navigate("/dashboard/trustap-account");
  }, [setErrorMessage, setIsLoading, state, token, navigate, code]);

  useEffect(() => {
    if (!token) return;
    if (hasFiredRef.current) return;
    hasFiredRef.current = true;
    verifyStateToken();
  }, [verifyStateToken, token]);

  return (
    <>
      <div className="bg-pink p-4">
        <div className="row">
          <div className="col-12">
            <div className="d-flex justify-content-between align-items-center">
              <h2 className="m-0">My Trustap Account</h2>
            </div>
          </div>
          <div className="col-12 mt-4">
            <p>Verifying your Trustap account...</p>
          </div>
        </div>
      </div>
    </>
  );
}

export default TrustapAccountCallback;
